import { connect } from "react-redux";

import { getDatasets, getLoading } from "redux/Datasets/selectors";

import ProgressBarLoaderWrapper from "views/uikit/ProgressBarLoader";
import PublicHeader from "views/components/PublicHeader";
import HealthStatus from "views/components/HealthStatus";
import DeprecatedVLButton from "views/uikit/DeprecatedVLButton";
import { State } from "redux/store";
import { useHandleDatasetCreation } from "hooks/useHandleDatasetCreation";

import styles from "./style.module.scss";
import { useUserConfig } from "../../../hooks/useUserConfig";
import {
  Guide,
  GuideBook,
  GuideButton,
  useAutoOpenGuide,
} from "views/components/Guide";
import {
  useInventoryGuideStore,
  useWelcomeGuideStore,
} from "views/components/Guide/guides/guideStores";
import { WELCOME_GUIDE_STEPS } from "views/components/Guide/guides/welcomeGuide";
import { INVENTORY_TOPICS } from "views/components/Guide/guides/pageGuides";

type HeaderProps = {
  isPrivatePath: boolean;
  datasets: any[];
  isLoading: boolean;
};

const PrivateDisplay = ({ handleButtonClick }: any) => {
  const { workspaces } = useUserConfig();
  const datasetCreationEnabled =
    (process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || "")
      .trim()
      .replace(/"/g, "") === "true" &&
    workspaces?.[0]?.permissions?.can_create_dataset;

  return (
    <div className={styles.headerRight}>
      <HealthStatus />
      {datasetCreationEnabled && (
        <DeprecatedVLButton
          text={"+ New Dataset"}
          onClick={handleButtonClick}
          tooltipText="Create a new dataset"
        />
      )}
    </div>
  );
};

function Header({ isLoading, isPrivatePath, datasets }: HeaderProps) {
  const { handleDatasetCreation: handleButtonClick } =
    useHandleDatasetCreation();

  const welcomeOpen = useWelcomeGuideStore((s) => s.open);
  const openWelcome = useWelcomeGuideStore((s) => s.openGuide);
  const closeWelcome = useWelcomeGuideStore((s) => s.closeGuide);
  const inventoryOpen = useInventoryGuideStore((s) => s.open);
  const openInventory = useInventoryGuideStore((s) => s.openGuide);
  const closeInventory = useInventoryGuideStore((s) => s.closeGuide);
  useAutoOpenGuide(useWelcomeGuideStore, isPrivatePath);

  const renderHeaderTitle = () => {
    return (
      <div className={styles.headerLeft}>
        <span className={styles.headerText}>All Datasets</span>
        {isPrivatePath && (
          <>
            <GuideButton
              inTitle
              tooltip="How the Dataset Inventory works"
              onClick={openInventory}
            />
            <button
              type="button"
              className={styles.quickStart}
              onClick={openWelcome}
            >
              Quick start
            </button>
          </>
        )}{" "}
        {datasets.length > 0 && (
          <span className={styles.datasetCountTitle}>
            Datasets{" "}
            <span className={styles.datasetCount}>{datasets.length}</span>
          </span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.headerContainer}>
      <Guide
        open={welcomeOpen}
        onClose={closeWelcome}
        steps={WELCOME_GUIDE_STEPS}
        size="wide"
      />
      <GuideBook
        open={inventoryOpen}
        onClose={closeInventory}
        heading="Dataset Inventory"
        topics={INVENTORY_TOPICS}
      />
      <div className={styles.upperRow}>
        {renderHeaderTitle()}
        {isPrivatePath ? (
          <PrivateDisplay handleButtonClick={handleButtonClick} />
        ) : (
          <PublicHeader isBig={true} />
        )}
      </div>
      <div className={styles.lowerRow}>
        <ProgressBarLoaderWrapper loading={isLoading} />
      </div>
    </div>
  );
}

function mapStatesToProps(state: State) {
  return {
    datasets: getDatasets(state),
    isLoading: getLoading(state),
  };
}

export default connect(mapStatesToProps)(Header);
